import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { blogPosts } from "./blogData";

function Blog({ url, Dissconnect, Metamask, WalletC }) {
  return (
    <div>
      <Navbar Dissconnect={Dissconnect} Metamask={Metamask} WalletC={WalletC} />

      <div className="container-kws p-t-2 p-b-5" style={{ minHeight: "100vh" }}>
        <div className="m-b-3">
          <h1 className="f-s-2_5 f-w-800 m-b-0_5">Blog</h1>
          <p className="g_clr f-s-1_25">
            Insights, guides and news from RamzMarketCap
          </p>
        </div>

        <div className="row g-4">
          {blogPosts.map((post) => (
            <div key={post.id} className="col-lg-4 col-md-6 col-12">
              <Link
                to={`/blog/${post.slug}`}
                style={{ textDecoration: "none" }}
              >
                <div
                  className="bg_g_clr box_shadow"
                  style={{
                    borderRadius: "12px",
                    padding: "1.5rem",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    cursor: "pointer",
                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-4px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <div className="m-b-1">
                    <span
                      className="b_clr f-w-600"
                      style={{
                        fontSize: "0.75rem",
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                        background: "rgba(0, 136, 255, 0.1)",
                        padding: "0.25rem 0.6rem",
                        borderRadius: "4px",
                      }}
                    >
                      {post.category}
                    </span>
                  </div>

                  <h2
                    className="f-w-600"
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.45",
                      marginBottom: "0.75rem",
                      flex: "1",
                    }}
                  >
                    {post.title}
                  </h2>

                  <p
                    className="g_clr"
                    style={{
                      fontSize: "0.9rem",
                      lineHeight: "1.6",
                      marginBottom: "1.25rem",
                    }}
                  >
                    {post.excerpt}
                  </p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      marginTop: "16px",
                    }}
                  >
                    <span className="g_clr" style={{ fontSize: "0.8rem" }}>
                      {post.date}
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Blog;
